import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { base_url } from '../../../Api/Api';
import { Loader } from '../../../Global/Loader';

import Header from '../../../Global/Header';
import ItemComment from './itemComment';

const Ticket = (props) => {

    const [state, setState] = useState({
        data: [],
        comments: [],
        loader: true
    })

    useEffect(() => {
        console.log(props.match.params.id)

        base_url.get(`ticket/${props.match.params.id}`)
            .then(response => {
                console.log(response.data.ticket)
                let tempData = response.data.ticket.comments
                let ticketData = {
                    'comment': response.data.ticket.message,
                    'jdate': response.data.ticket.jdate,
                    'image': response.data.ticket.image,
                    'is_reply': false
                }
                tempData.push(ticketData)
                setState({
                    ...state,
                    data: response.data.ticket,
                    comments: tempData.reverse(),
                    loader: false
                })
                setTimeout(() => {
                    let offsetHeightEl = document.getElementsByClassName('inner-body')[0].offsetHeight;
                    document.getElementsByClassName('body-ticket')[0].scrollTo(0, offsetHeightEl)
                }, 1000);
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, []);

    return (
        <React.Fragment>
            <Loader
                active={state.loader} />
            <div className={`instructpg ticket ${state.loader ? '' : 'active'}`}>
                <Header
                    innerPage={true}
                    title={`تیکت ${state.data.length == 0 ? '' : state.data.id} `} />
                {state.data.length == 0 ? '' :
                    <span className={`msg-status ${state.data.status == 'close' ? 'closed' : state.data.status == 'open' ? '' : 'opened'}`}>
                        {state.data.status_message}
                    </span>
                }
                <div className="body-ticket">
                    <div className="inner-body">
                        {state.data.length == 0 ?
                            <span className="no-info"> <i className="icon-comment"></i>پیام وجود ندارد.</span>
                            :
                            state.comments.length == 0 ?
                                <span className="no-info"> <i className="icon-comment"></i>پیام وجود ندارد.</span>
                                :
                                state.comments.map(item =>
                                    <ItemComment
                                        data={item} />
                                )
                        }
                    </div>
                </div>
                {state.data.length == 0 ? null :
                    state.data.status == 'close' ?
                        <div className="btn-base btn-black btn-sircle btn-expired">
                            <Button
                                variant="contained">ارسال پاسخ</Button>
                        </div>
                        :
                        <div className="btn-base btn-black btn-sircle">
                            <Link to={`/tickets/replay-ticket/${state.data.id}`} >
                                ارسال پاسخ
                            </Link>
                        </div>
                }
            </div>
        </React.Fragment >
    );
}

export default Ticket;